export const routesKullanicilar = [
  {
    path: "/kullanicilar",
    name: "kullanicilar",
    component: () => import("@/views/kullanicilar/index.vue"),
    meta: {
      public: false,
      title: "kullanicilar.Kullanıcılar",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/kullanicilar/:userId",
    name: "kullanicilar_profil",
    component: () => import("@/views/kullanicilar/profil/index.vue"),
    meta: {
      public: false,
      title: "kullanicilar.Kullanıcı Profil",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/kullanici_grafik",
    name: "kullanici_grafik",
    component: () => import("@/views/kullanicilar/grafik/index.vue"),
    meta: {
      public: false,
      title: "kullanicilar.Grafikler",
    },
  },
  {
    path: "/groupyetki",
    name: "groupyetki",
    component: () => import("@/views/kullanicilar/groupyetki/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102] },
      title: "kullanicilar.Group Yetki",
    },
  },
  {
    path: "/yetki",
    name: "yetki",
    component: () => import("@/views/kullanicilar/yetki/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102] },
      title: "kullanicilar.Yetki",
    },
  },
]
